"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = exports.iconMap = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var common_1 = require("./common");

var icons_1 = require("./icons");

exports.iconMap = {
  warning: icons_1.Alert,
  'arrow-back': icons_1.ArrowBack,
  'arrow-down': icons_1.ArrowDown,
  'arrow-down-filled': icons_1.ArrowDownFilled,
  'calendar-note': icons_1.CalendarNote,
  close: icons_1.Close,
  copy: icons_1.Copy,
  email: icons_1.Email,
  error: icons_1.Error,
  facebook: icons_1.Facebook,
  'facebook-messenger': icons_1.FacebookMessenger,
  'facebook-square': icons_1.FacebookSquare,
  google: icons_1.Google,
  heart: icons_1.Heart,
  'heart-filled': icons_1.HeartFilled,
  linkedin: icons_1.Linkedin,
  'linkedin-square': icons_1.LinkedinSquare,
  plus: icons_1.Plus,
  share: icons_1.Share,
  sms: icons_1.SMS,
  sso: icons_1.SSO,
  ticket: icons_1.Ticket,
  twitter: icons_1.Twitter,
  website: icons_1.Website,
  whatsapp: icons_1.WhatsApp,
  'new-tab': icons_1.NewTab
};
/**
 * @deprecated use the `@hopin-team/ui-icon` component instead.
 */

function Icon(_a) {
  var description = _a.description,
      _b = _a.fill,
      fill = _b === void 0 ? common_1.defaultFill : _b,
      icon = _a.icon,
      title = _a.title,
      props = tslib_1.__rest(_a, ["description", "fill", "icon", "title"]);

  var Component = exports.iconMap[icon];
  return react_1.default.createElement(Component, tslib_1.__assign({
    fill: fill,
    "aria-labelledby": (0, common_1.getAriaLabel)({
      title: title,
      description: description
    }),
    role: "img"
  }, props), react_1.default.createElement("title", {
    id: (0, common_1.toIconTitleId)(title)
  }, title), description && react_1.default.createElement("desc", {
    id: (0, common_1.toIconDescriptionId)(description)
  }, description));
}

exports.Icon = Icon;